// src/pages/InstructionsPage/InstructionsPage.tsx
import React, { useEffect, useState } from 'react';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import { V } from '../../services/obfyscatedStrings';

import './InstructionsPage.scss';

interface Instruction {
    id: string;
    platform: string;
    icon: string;
    steps: string[];
}

function InstructionsPage() {
    const [selectedPlatform, setSelectedPlatform] = useState<string>('windows');

    const instructions: Instruction[] = [
        {
            id: 'windows',
            platform: 'Windows',
            icon: '💻',
            steps: [
                'Скачайте приложение для Windows с официального сайта',
                'Запустите установочный файл и следуйте инструкциям',
                'После установки откройте приложение',
                'Войдите в аккаунт используя Telegram',
                'Нажмите кнопку "Подключить" для установки соединения'
            ]
        },
        {
            id: 'macos',
            platform: 'macOS',
            icon: '🍎',
            steps: [
                'Скачайте приложение для macOS из App Store',
                'Установите приложение, перетащив его в папку Программы',
                'Запустите приложение из Launchpad',
                'Авторизуйтесь через Telegram',
                'Разрешите необходимые разрешения в настройках системы',
                `Подключитесь к ${V()}`
            ]
        },
        {
            id: 'ios',
            platform: 'iOS',
            icon: '📱',
            steps: [
                'Скачайте приложение из App Store',
                'Откройте приложение после установки',
                'Нажмите "Войти через Telegram"',
                'Подтвердите вход в боте',
                `Нажмите "Подключить" для активации ${V()}`,
                `При первом подключении разрешите добавить конфигурацию ${V()}`
            ]
        },
        {
            id: 'android',
            platform: 'Android',
            icon: '📱',
            steps: [
                'Скачайте приложение из Google Play или с официального сайта',
                'Установите APK файл (разрешите установку из неизвестных источников)',
                'Откройте приложение',
                'Авторизуйтесь через Telegram',
                `Разрешите создание ${V()}-подключения`,
                'Нажмите кнопку подключения'
            ]
        }
    ];

    useEffect(() => {
        const tg = (window as any).Telegram?.WebApp;
        if (tg) {
            tg.ready();
            tg.expand();
            tg.setHeaderColor?.('#000000');
            tg.setBackgroundColor?.('#000000');
        }
    }, []);

    const currentInstruction = instructions.find(i => i.id === selectedPlatform);

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar />

            <div className="instructions-page">
                {/* Заголовок как в профиле */}
                <h1 className="page-main-title">Установка на другом устройстве</h1>
                <p className="page-main-subtitle">Подробная инструкция для установки</p>

                {/* Селектор платформ */}
                <div className="platform-section">
                    <div className="platform-grid">
                        {instructions.map(platform => (
                            <button
                                key={platform.id}
                                className={`platform-card ${selectedPlatform === platform.id ? 'active' : ''}`}
                                onClick={() => setSelectedPlatform(platform.id)}
                            >
                                <span className="platform-card-icon">{platform.icon}</span>
                                <span className="platform-card-name">{platform.platform}</span>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Инструкция */}
                {currentInstruction && (
                    <div className="instruction-card">
                        <div className="instruction-card-header">
                            <div className="instruction-icon">
                                <span>{currentInstruction.icon}</span>
                            </div>
                            <h2 className="instruction-title">{currentInstruction.platform}</h2>
                        </div>

                        <div className="steps-container">
                            {currentInstruction.steps.map((step, index) => (
                                <div key={index} className="step-item">
                                    <div className="step-number">{index + 1}</div>
                                    <p className="step-text">{step}</p>
                                </div>
                            ))}
                        </div>

                        <button className="download-button">
                            Скачать для {currentInstruction.platform}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default InstructionsPage;